var main = {

  userID : null,
  signInStatus : null,

  ready : function ( evt ) {
    $.ajax({
      url: '/ajax/AJAX-main/get-sign-in-status',
      dataType: 'json',
      success: function ( returnedData ) {
        main.userID = returnedData.userID;
        main.signInStatus = returnedData.signInStatus;
      },
    });

    // - FORMS
    if ( $('form').length > 0 ) {
      forms.init();
    }
  },

  view : function ( url, id, success ) {
    $.ajax({
      url      : url,
      data     : '&id=' + id,
      type     : 'post',
      dataType : 'json',
      success  : success,
    });
  },

  edit : function ( url, id, success ) {
    $.ajax({
      url      : url,
      data     : '&id=' + id,
      type     : 'post',
      dataType : 'json',
      success  : success,
    });
  },

  delete : function ( url, id, success ) {
    $.ajax({
      url      : url,
      data     : '&id=' + id,
      type     : 'post',
      dataType : 'json',
      success  : success,
    });
  },

  /**
   * FLASH DATA
   */

  flashData : {

    show : function ( content, className, _disappear ) {
      var disappear;
      if ( _disappear === undefined ) {
        disappear = 4;
      }
      else if ( _disappear > 0 ) {
        disappear = _disappear;
      }
      else {
        disappear = false;
      }

      $('#flash-data').removeClass ( 'positive' );
      $('#flash-data').removeClass ( 'negative' );
      $('#flash-data').removeClass ( 'neutral' );

      $('#flash-data').addClass ( className );

      $('#flash-data .content').html ( content );

      TweenMax.to ( $('#flash-data'), 0.5, {
        top: 0,
      });

      $('.flash-data .close-btn')
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
        main.flashData.hide();
      });

      if ( disappear !== false ) {
        TweenMax.to ( $('#flash-data'), 0.5, {
          top: (-$('#flash-data').outerHeight()-1) + 'px',
          delay: disappear,
        });
      }
    },

    hide : function() {
      $('.flash-data .close-btn').off ( 'click' );

      TweenMax.killTweensOf ( $('#flash-data') );

      TweenMax.to ( $('#flash-data'), 0.5, {
        top: (-$('#flash-data').outerHeight()-1) + 'px',
      });
    },

  },

   working : {
      show : function(message) {
          $('.generic-blackout').show();
          $('#working').show();
          $('#working-message').text(message);
      },

      hide : function() {
          $('.generic-blackout').hide();
          $('#working').hide();
          $('#working-message').text('');
      }
   },

  flashButton : function ( selector ) {
    TweenMax.delayedCall ( 0.5, function() {
      $(selector).addClass ( 'flash-button-on' );
    });

    TweenMax.delayedCall ( 1, function() {
      $(selector).removeClass ( 'flash-button-on' );
    });

    TweenMax.delayedCall ( 1.5, function() {
      $(selector).addClass ( 'flash-button-on' );
    });

    TweenMax.delayedCall ( 2, function() {
      $(selector).removeClass ( 'flash-button-on' );
    });
  },

  shuffle : function ( array ) {
    var copy = [], n = array.length, i;

    // While there remain elements to shuffle…
    while (n) {

      // Pick a remaining element…
      i = Math.floor(Math.random() * n--);

      // And move it to the new array.
      copy.push(array.splice(i, 1)[0]);
    }

    return copy;
  },

  manualReset : {
    activated : false,
    activatedINT : null,
    found : null,
    
    activateCheck : function() {
      $('body').on ( 'mousedown.mrr', function(evt) {
        main.manualReset.check();

        main.manualReset.activatedINT = setInterval ( function() {
          main.manualReset.check();
        }, 10000);

        $('body').off ( 'mousedown.mrr' );
      });
    },

    deactivateCheck : function() {
      clearInterval ( main.manualReset.activatedINT );
    },

    check : function() {
      $.ajax({
        url: '/ajax/AJAX-main/get-total-manual-reset-requests',
        method: 'post',
        dataType: 'json',
        success: function ( returnedData ) {
          if ( returnedData.success ) {
            if ( returnedData.total > 0 ) {
              main.manualReset.playSound();
            }
            else {
              main.manualReset.stopSound();
            }
          }
        },
        error: function(err) {
          console.log(err);
        },
      });
    },

    playSound : function() {
      var audio = document.getElementById('manual-reset-audio');
      audio.play();
    },

    stopSound : function() {
      var audio = document.getElementById('manual-reset-audio');
      audio.pause();
      audio.currentTime = 0;
    },
  },

};

$(document).ready ( function ( evt ) {
  main.ready ( evt );
});
